export type { IMaskedInputInterface } from './masked-input';

export { default } from './masked-input';
